import { withStyles, Grid, Typography, Paper } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import styles, { StyledComponent } from '../../../../../styles/styles';
import { LabeledValue } from '../../../../../controls/labeled-value';
import { connect } from 'react-redux';
import { State } from '../../../../../redux/root-reducer';
import { FormDetails, getFormDetails } from '../form-details-reducer';
import { getDisplayDate } from '../../../../../shared-functions';
import { ExpansionPanel } from '../../../../../forms/form-components/expansion-panel/expansion-panel';

interface BaseProps {
    formDetails?: FormDetails;
}

interface Props extends BaseProps, StyledComponent {}

const inabilityToPerformOccupationView: React.FunctionComponent<Props> = ({
    classes,
    formDetails,
}: Props) => {
    const inabilityToPerformOccupation =
        formDetails?.claimInformation?.detailsOfInabilityToPerformOccupation;
    const hasImpactedOccupation =
        inabilityToPerformOccupation?.hasYourMedicalConditionImpactedYourAbilityToPerformYourOccupation;

    return (
        <React.Fragment>
            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid container item xs={10} alignItems="center">
                    <Typography style={{ padding: 10 }} className={classes.heading} variant="body1">
                        Details of your inability to perform your occupation
                    </Typography>
                </Grid>
            </Grid>
            <Paper className={classes.paper}>
                <Grid container justify="flex-start">
                    <Grid item xs={12} container justify="flex-start">
                        <Grid item xs={4} lg={3}>
                            <LabeledValue
                                label="Has your medical condition impacted on your ability to perform your occupation?"
                                value={hasImpactedOccupation}
                            />
                        </Grid>
                        {hasImpactedOccupation === 'Yes' && (
                            <React.Fragment>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Please provide full details of the medical condition and how it has impacted your ability to perform your occupation."
                                        value={
                                            inabilityToPerformOccupation?.pleaseProvideDetailsIfTheMedicalConditionHasHadAnImpactOnYourPerformanceAsAnEmployee
                                        }
                                    />
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="What date did you stop working?"
                                        value={getDisplayDate(
                                            inabilityToPerformOccupation?.whatDateDidYouStopWorking
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="When do you expect to return to work?"
                                        value={getDisplayDate(
                                            inabilityToPerformOccupation?.whenWillYouBeReturningToWork
                                        )}
                                    />
                                </Grid>
                            </React.Fragment>
                        )}
                        {hasImpactedOccupation !== 'No' && (
                            <React.Fragment>
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Will you be returning to work Full Time or Part Time?"
                                        value={
                                            inabilityToPerformOccupation?.willYouBeReturningToWorkFullTimeOrPartTime
                                        }
                                    />
                                </Grid>
                                {(inabilityToPerformOccupation?.willYouBeReturningToWorkFullTimeOrPartTime ===
                                    'Full Time' ||
                                    inabilityToPerformOccupation?.willYouBeReturningToWorkFullTimeOrPartTime ===
                                        'Part Time') && (
                                    <Grid item xs={4} lg={3}>
                                        <LabeledValue
                                            label="Please provide details on how many hours will you be working per week and others."
                                            value={
                                                inabilityToPerformOccupation?.pleaseProvideDetailsOfTheHoursYouWillBeWorking
                                            }
                                        />
                                    </Grid>
                                )}
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Are you currently losing an income due to your medical condition?"
                                        value={
                                            inabilityToPerformOccupation?.areYouCurrentlyLosingAnIncomeDueToYourMedicalCondition
                                        }
                                    />
                                </Grid>
                                {inabilityToPerformOccupation?.areYouCurrentlyLosingAnIncomeDueToYourMedicalCondition ===
                                    'Yes' && (
                                    <Grid item xs={6} lg={6}>
                                        <LabeledValue
                                            label="Please provide full details i.e. sources of income lost as well as what percentage of the income has been lost"
                                            value={
                                                inabilityToPerformOccupation?.pleaseProvideCompleteDetailsOfHowThisConditionHasAffectedYourIncome
                                            }
                                        />
                                    </Grid>
                                )}
                                <Grid item xs={6} lg={6}>
                                    <LabeledValue
                                        label="On what date did you last receive a full income?"
                                        value={getDisplayDate(
                                            inabilityToPerformOccupation?.onWhatDateDidYouLastReceiveAFullIncome
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={6} lg={6}>
                                    <LabeledValue
                                        label="Have you received any income or any benefits since the above date?"
                                        value={
                                            inabilityToPerformOccupation?.haveYouReceivedAnyIncomeOrAnyBenefitsSinceTheAboveDate
                                        }
                                    />
                                </Grid>
                                <Grid container spacing={2} className={classes.marginTop2}>
                                    {inabilityToPerformOccupation?.haveYouReceivedAnyIncomeOrAnyBenefitsSinceTheAboveDate ===
                                        'Yes' && (
                                        <React.Fragment>
                                            <Grid
                                                container
                                                justify="space-between"
                                                className={classes.marginTop2}
                                            >
                                                <Grid container item xs={10} alignItems="center">
                                                    <Typography
                                                        style={{ padding: 10 }}
                                                        className={classes.heading}
                                                        variant="body1"
                                                    >
                                                        Source of income
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            {inabilityToPerformOccupation?.sourcesOfIncome?.map(
                                                (income: any, index: number) => (
                                                    <Grid key={index}>
                                                        <ExpansionPanel
                                                            name={`Source of income ${index + 1}`}
                                                        >
                                                            <Grid container justify="flex-start">
                                                                <Grid item xs={4} lg={3}>
                                                                    <LabeledValue
                                                                        label="Source of income since disablement"
                                                                        value={
                                                                            income.sourceOfIncome
                                                                        }
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={4} lg={3}>
                                                                    <LabeledValue
                                                                        label="Income Amount"
                                                                        value={income.incomeAmount}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={4} lg={3}>
                                                                    <LabeledValue
                                                                        label="Date income was received"
                                                                        value={getDisplayDate(
                                                                            income.datePaymentReceived
                                                                        )}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </ExpansionPanel>
                                                    </Grid>
                                                )
                                            )}
                                        </React.Fragment>
                                    )}
                                </Grid>
                            </React.Fragment>
                        )}
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    );
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails ?? getFormDetails(state),
});

const mapDispatchToProps = {};

export const InabilityToPerformOccupationView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(inabilityToPerformOccupationView));
